module.exports = __webpack_public_path__ + "skill_technical.c2e3a596.svg";